//flow
import AsyncExportHandler from 'common/components/common/export/AsyncExportHandler';
import {
    requestEntitiesExport as entitiesExportApi,
    fetchExportStatus as entitiesExportStatusApi
} from 'common/middleware/api';

export default class EntityExportHandler extends AsyncExportHandler {
    constructor() {
        super(entitiesExportApi, entitiesExportStatusApi);
    }
}
